import React from 'react';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import {
    loadConfigureState,
    saveConfigureState,
    mergeConfigureState,
    resetConfigureStateToDemo
} from './statePersistence';
import kpiRegistryData from './newkpiRegistryData.json';
import dummyData from './newdummyData.json';
import QualdoDataTable from '../../components/bootstrapTable';
import { DeleteWarningModal } from '../../components/DeleteWarningModal';
import KpiDashboardCards from './KpiDashboardCards';
import EntityModal from './EntityModal';
import QuickAddModal from './QuickAddModal';
import { ChevronRight, Search, Plus, ChevronsDown, ChevronsUp, Pencil, Trash2 } from 'lucide-react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faToggleOn, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const BIZ_SVG = (
    <svg className='tw-block' xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g>
            <path d="M9.43582 5.9987C9.26448 5.9987 9.12137 5.9412 9.00648 5.8262C8.89148 5.71131 8.83398 5.56692 8.83398 5.39303V2.93786C8.83398 2.76386 8.89193 2.61942 9.00782 2.50453C9.12371 2.38953 9.26726 2.33203 9.43848 2.33203H13.0655C13.2368 2.33203 13.3799 2.38953 13.4948 2.50453C13.6098 2.61942 13.6673 2.76386 13.6673 2.93786V5.39303C13.6673 5.56692 13.6094 5.71131 13.4935 5.8262C13.3776 5.9412 13.234 5.9987 13.0628 5.9987H9.43582ZM2.93582 8.33203C2.76448 8.33203 2.62137 8.27453 2.50648 8.15953C2.39148 8.04453 2.33398 7.90203 2.33398 7.73203V2.93186C2.33398 2.76186 2.39193 2.61942 2.50782 2.50453C2.62371 2.38953 2.76726 2.33203 2.93848 2.33203H6.56548C6.73682 2.33203 6.87993 2.38953 6.99482 2.50453C7.10982 2.61953 7.16732 2.93203 7.16732 2.93203V7.7322C7.16732 7.9022 7.10937 8.04464 6.99348 8.15953C6.8776 8.27453 6.73404 8.33203 6.56282 8.33203H2.93582ZM9.43582 13.6654C9.26448 13.6654 9.12137 13.6079 9.00648 13.4929C8.89148 13.3779 8.83398 13.2354 8.83398 13.0654V8.2652C8.83398 8.0952 8.89193 7.95275 9.00782 7.83786C9.12371 7.72286 9.26726 7.66536 9.43848 7.66536H13.0655C13.2368 7.66536 13.3799 7.72286 13.4948 7.83786C13.6098 7.95286 13.6673 8.09536 13.6673 8.26536V13.0655C13.6673 13.2355 13.6094 13.378 13.4935 13.4929C13.3776 13.6079 13.234 13.6654 13.0628 13.6654H9.43582ZM2.93582 13.6654C2.76448 13.6654 2.62137 13.6079 2.50648 13.4929C2.39148 13.378 2.33398 13.2335 2.33398 13.0595V10.6044C2.33398 10.4305 2.39193 10.2861 2.50782 10.1712C2.62371 10.0562 2.76726 9.9987 2.93848 9.9987H6.56548C6.73682 9.9987 6.87993 10.0562 6.99482 10.1712C7.10982 10.2861 7.16732 10.4305 7.16732 10.6044V13.0595C7.16732 13.2335 7.10937 13.378 6.99348 13.4929C6.8776 13.6079 6.73404 13.6654 6.56282 13.6654H2.93582Z" fill="currentColor" />
        </g>
    </svg>
);

const FN_SVG = (
    <svg className='tw-block' xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g>
            <path d="M3.077 12.6654C2.77011 12.6654 2.51389 12.5626 2.30833 12.357C2.10278 12.1515 2 11.8953 2 11.5884V4.40903C2 4.10214 2.10278 3.84592 2.30833 3.64036C2.51389 3.43481 2.77011 3.33203 3.077 3.33203H5.95C6.09356 3.33203 6.23311 3.36109 6.36867 3.4192C6.50411 3.47731 6.62011 3.55464 6.71667 3.6512L7.73083 4.66536H12.923C13.2299 4.66536 13.4861 4.76814 13.6917 4.9737C13.8972 5.17925 14 5.43548 14 5.74236V11.5884C14 11.8953 13.8972 12.1515 13.6917 12.357C13.4861 12.5626 13.2299 12.6654 12.923 12.6654H3.077Z" fill="currentColor" />
        </g>
    </svg>
);

const KPI_SVG = (
    <svg className='tw-block' xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 18 18" fill="none">
        <path d="M14.7695 3.375C15.1483 3.37508 15.469 3.50613 15.7314 3.76855C15.9939 4.03098 16.1249 4.35174 16.125 4.73047V13.2695C16.1249 13.6483 15.9939 13.969 15.7314 14.2314C15.469 14.4939 15.1483 14.6249 14.7695 14.625H3.23047C2.85174 14.6249 2.53098 14.4939 2.26855 14.2314C2.00613 13.969 1.87508 13.6483 1.875 13.2695V4.73047C1.87508 4.35174 2.00613 4.03098 2.26855 3.76855C2.53098 3.50613 2.85174 3.37508 3.23047 3.375H14.7695ZM4.5 6.75V10.8281H5.49316V9.02734L6.86426 10.8281H8.0791L6.44043 8.74902L8.02051 6.75H6.85254L5.49316 8.53906V6.75H4.5ZM8.55078 10.8281H9.54395V9.36426H10.1602C11.1999 9.36426 11.659 8.73726 11.6592 8.06348C11.6592 7.314 11.1595 6.75 10.1602 6.75H8.55078V10.8281ZM12.1768 10.8281H13.1699V6.75H12.1768V10.8281ZM10.085 7.55176C10.4799 7.55183 10.6484 7.7498 10.6484 8.06348C10.6483 8.3769 10.4797 8.57414 10.085 8.57422H9.54395V7.55176H10.085Z" fill="currentColor" />
    </svg>
);

const MDL_SVG = (
    <svg className='tw-block' xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M7.39815 14.1377L2.93665 11.5697C2.74687 11.4604 2.59898 11.3143 2.49298 11.1314C2.38698 10.9484 2.33398 10.7475 2.33398 10.5287V5.47239C2.33398 5.25361 2.38698 5.05272 2.49298 4.86972C2.59898 4.68683 2.74687 4.54072 2.93665 4.43139L7.39815 1.86339C7.58782 1.75394 7.78865 1.69922 8.00065 1.69922C8.21265 1.69922 8.41348 1.75394 8.60315 1.86339L13.0647 4.43139C13.2544 4.54072 13.4023 4.68683 13.5083 4.86972C13.6143 5.05272 13.6673 5.25361 13.6673 5.47239V10.5287C13.6673 10.7475 13.6143 10.9484 13.5083 11.1314C13.4023 11.3143 13.2544 11.4604 13.0647 11.5697L8.60315 14.1377C8.41348 14.2472 8.21265 14.3019 8.00065 14.3019C7.78865 14.3019 7.58782 14.2472 7.39815 14.1377ZM7.50065 8.28772V13.0467L7.91082 13.2826C7.94082 13.2997 7.97076 13.3082 8.00065 13.3082C8.03054 13.3082 8.06048 13.2997 8.09048 13.2826L8.50065 13.0467V8.28772L12.6673 5.87489V5.44422C12.6673 5.42277 12.662 5.40139 12.6513 5.38005C12.6406 5.35872 12.6246 5.34161 12.6032 5.32872L12.1173 5.04672L8.00065 7.42622L3.88398 5.04672L3.39815 5.32872C3.37671 5.34161 3.36065 5.35872 3.34998 5.38005C3.33932 5.40139 3.33398 5.42277 3.33398 5.44422V5.87489L7.50065 8.28772Z" fill="currentColor" />
    </svg>
);

const PRIO_OPTS = [
    { value: 'critical', label: 'Critical' },
    { value: 'high', label: 'High' },
    { value: 'medium', label: 'Medium' },
    { value: 'low', label: 'Low' }
];

class KpiCatalogWorkspace extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            businesses: [],
            functions: [],
            kpis: [],
            models: [],
            assets: [],
            mappings: [],

            showInactive: true,
            searchQuery: '',
            showWorkflowGuide: false,

            openNodes: {},
            isFullyExpanded: false,

            // Entity Modal
            entityModal: {
                show: false,
                type: 'business',
                id: null,
                presetParentId: null,
                name: '',
                description: '',
                priority: '',
                formula: '',
                kind: 'Forecasting',
                errors: {}
            },

            // Quick Add Modal
            quickAddModal: {
                show: false,
                name: '',
                description: '',
                functions: [
                    { name: '', description: '', kpis: [], models: [] }
                ],
                errors: {}
            },

            // Delete modal
            showDeleteModal: false,
            deleteTarget: { type: null, id: null },

            // Deactivate modal
            showDeactivateModal: false,
            deactivateTarget: { type: null, id: null },

            openDropdownId: null,
            dropdownCoords: { top: 0, left: 0 },

            toast: {
                show: false,
                message: '',
                isError: false
            }
        };
    }

    componentDidMount() {
        this.loadState();
        window.addEventListener('qualdo-state-update', this.handleGlobalStateUpdate);
        document.addEventListener('click', this.handleDocumentClick);
    }

    componentWillUnmount() {
        window.removeEventListener('qualdo-state-update', this.handleGlobalStateUpdate);
        document.removeEventListener('click', this.handleDocumentClick);
    }

    handleDocumentClick = (event) => {
        if (!this.state.openDropdownId) return;

        // If click is inside the custom dropdown menu or the toggle button, do not close it
        const isMenuClick = event.target.closest('.custom-dropdown-menu');
        const isButtonClick = event.target.closest('.kr-actions-toggle');
        
        if (!isMenuClick && !isButtonClick) {
            this.setState({ openDropdownId: null });
        }
    };

    handleToggleDropdown = (e, id) => {
        e.stopPropagation();
        if (e.nativeEvent) {
            e.nativeEvent.stopPropagation();
            if (e.nativeEvent.stopImmediatePropagation) {
                e.nativeEvent.stopImmediatePropagation();
            }
        }
        const { openDropdownId } = this.state;
        if (openDropdownId === id) {
            this.setState({ openDropdownId: null });
        } else {
            const rect = e.currentTarget.getBoundingClientRect();
            this.setState({
                openDropdownId: id,
                dropdownCoords: {
                    top: rect.bottom + 4,
                    left: rect.right - 180
                }
            });
        }
    };

    loadState = () => {
        let state = loadConfigureState();
        const businessNames = (state.businesses || []).map((b) => b.name);
        const hasLegacyCatalog = businessNames.includes('Commercial');
        const expectedKpiCount = (kpiRegistryData.kpis || []).length;
        const expectedMappingCount = (dummyData.mappings || []).length;
        const currentKpiCount = (state.kpis || []).length;
        const currentMappingCount = (state.mappings || []).length;
        // Force reseed when legacy/empty/stale catalog is cached.
        if (
            !businessNames.length
            || hasLegacyCatalog
            || currentKpiCount !== expectedKpiCount
            || currentMappingCount !== expectedMappingCount
        ) {
            state = resetConfigureStateToDemo();
        }
        this.setState({
            businesses: state.businesses || [],
            functions: state.functions || [],
            kpis: state.kpis || [],
            models: state.models || [],
            assets: state.assets || [],
            mappings: state.mappings || []
        }, this.initializeOpenNodes);
    };

    handleGlobalStateUpdate = (e) => {
        const { businesses, functions, kpis, models, assets, mappings } = e.detail;
        this.setState({ businesses, functions, kpis, models, assets, mappings });
    };

    initializeOpenNodes = () => {
        const nextOpen = { ...this.state.openNodes };
        this.state.businesses.forEach(b => {
            if (nextOpen['b' + b.id] === undefined) {
                nextOpen['b' + b.id] = true;
            }
        });
        this.setState({ openNodes: nextOpen });
    };

    saveState = (updatedState, callback) => {
        const next = mergeConfigureState(this.state, updatedState);
        saveConfigureState(next);
        this.setState(updatedState, callback);
    };

    showToast = (message, isError = false) => {
        this.setState({
            toast: { show: true, message, isError }
        });
    };

    hideToast = () => {
        this.setState(prevState => ({
            toast: { ...prevState.toast, show: false }
        }));
    };

    // Helper Getters
    getBiz = id => this.state.businesses.find(b => b.id === id);
    getFn = id => this.state.functions.find(f => f.id === id);
    getKpi = id => this.state.kpis.find(k => k.id === id);
    getModel = id => this.state.models.find(m => m.id === id);
    getFnsOf = bid => this.state.functions.filter(f => f.businessId === bid);
    getKpisOf = fid => this.state.kpis.filter(k => k.functionId === fid);
    getModelsOf = fid => this.state.models.filter(m => m.functionId === fid);
    getMapsOf = kid => this.state.mappings.filter(m => m.kpiId === kid);

    isBizEff = b => !!(b && b.active);
    isFnEff = f => !!(f && f.active && this.isBizEff(this.getBiz(f.businessId)));
    isKpiEff = k => !!(k && k.active && this.isFnEff(this.getFn(k.functionId)));
    isModelEff = m => !!(m && m.active && this.isFnEff(this.getFn(m.functionId)));

    getRegistryCounts = () => {
        const { businesses, functions, kpis, models } = this.state;
        return {
            biz: [businesses.filter(this.isBizEff).length, businesses.length],
            fn: [functions.filter(this.isFnEff).length, functions.length],
            kpi: [kpis.filter(this.isKpiEff).length, kpis.length],
            model: [models.filter(this.isModelEff).length, models.length]
        };
    };

    handleExpandAll = () => {
        const nextOpen = {};
        this.state.businesses.forEach(b => {
            nextOpen['b' + b.id] = true;
            this.getFnsOf(b.id).forEach(f => {
                nextOpen['f' + f.id] = true;
                this.getKpisOf(f.id).forEach(k => {
                    nextOpen['k' + k.id] = true;
                });
            });
        });
        this.setState({ openNodes: nextOpen, isFullyExpanded: true });
    };

    handleCollapseAll = () => {
        const nextOpen = {};
        this.state.businesses.forEach(b => {
            nextOpen['b' + b.id] = false;
        });
        this.setState({ openNodes: nextOpen, isFullyExpanded: false });
    };

    handleToggleNode = (key) => {
        this.setState(prevState => {
            const isB = key.startsWith('b');
            const current = prevState.openNodes[key] !== undefined 
                ? prevState.openNodes[key] 
                : isB;
            const willBeOpen = !current;
            return {
                openNodes: {
                    ...prevState.openNodes,
                    [key]: willBeOpen
                },
                isFullyExpanded: willBeOpen ? prevState.isFullyExpanded : false
            };
        });
    };

    handleToggleActive = (type, id) => {
        const obj = type === 'business' ? this.getBiz(id) :
                    type === 'function' ? this.getFn(id) :
                    type === 'kpi' ? this.getKpi(id) : this.getModel(id);

        if (!obj) return;

        const goingInactive = obj.active;
        let childCount = 0;
        if (type === 'business') {
            childCount = this.getFnsOf(id).length;
        } else if (type === 'function') {
            childCount = this.getKpisOf(id).length + this.getModelsOf(id).length;
        }

        const applyToggle = () => {
            let nextState = {};
            const key = type === 'business' ? 'businesses' :
                        type === 'function' ? 'functions' :
                        type === 'kpi' ? 'kpis' : 'models';

            nextState[key] = this.state[key].map(item => 
                item.id === id ? { ...item, active: !item.active } : item
            );

            this.saveState(nextState, () => {
                this.showToast(obj.active ? 'Deactivated' : 'Activated');
            });
        };

        if (goingInactive && childCount > 0) {
            this.setState({
                showDeactivateModal: true,
                deactivateTarget: { type, id }
            });
        } else {
            applyToggle();
        }
    };

    handleConfirmDeactivate = () => {
        const { type, id } = this.state.deactivateTarget;
        if (!type || !id) return;

        let nextState = {};
        const key = type === 'business' ? 'businesses' : 'functions';

        nextState[key] = this.state[key].map(item => 
            item.id === id ? { ...item, active: false } : item
        );

        this.saveState(nextState, () => {
            this.setState({ showDeactivateModal: false, deactivateTarget: { type: null, id: null } });
            this.showToast('Deactivated');
        });
    };

    handleDeleteEntity = (type, id) => {
        this.setState({
            showDeleteModal: true,
            deleteTarget: { type, id }
        });
    };

    handleConfirmDelete = () => {
        const { type, id } = this.state.deleteTarget;
        if (!type || !id) return;

        const fnIds = new Set();
        const kpiIds = new Set();

        let nextBusinesses = [...this.state.businesses];
        let nextFunctions = [...this.state.functions];
        let nextKpis = [...this.state.kpis];
        let nextModels = [...this.state.models];
        let nextMappings = [...this.state.mappings];

        if (type === 'business') {
            this.getFnsOf(id).forEach(f => {
                fnIds.add(f.id);
                this.getKpisOf(f.id).forEach(k => kpiIds.add(k.id));
            });
            nextFunctions = nextFunctions.filter(f => f.businessId !== id);
            nextBusinesses = nextBusinesses.filter(b => b.id !== id);
        } else if (type === 'function') {
            fnIds.add(id);
            this.getKpisOf(id).forEach(k => kpiIds.add(k.id));
            nextFunctions = nextFunctions.filter(f => f.id !== id);
        } else if (type === 'kpi') {
            kpiIds.add(id);
            nextKpis = nextKpis.filter(k => k.id !== id);
        } else {
            nextModels = nextModels.filter(m => m.id !== id);
        }

        if (fnIds.size > 0) {
            nextKpis = nextKpis.filter(k => !fnIds.has(k.functionId));
            nextModels = nextModels.filter(m => !fnIds.has(m.functionId));
        }

        if (kpiIds.size > 0) {
            nextMappings = nextMappings.filter(m => !kpiIds.has(m.kpiId));
        }

        const label = type.charAt(0).toUpperCase() + type.slice(1);
        this.saveState({
            businesses: nextBusinesses,
            functions: nextFunctions,
            kpis: nextKpis,
            models: nextModels,
            mappings: nextMappings
        }, () => {
            this.setState({ showDeleteModal: false, deleteTarget: { type: null, id: null } });
            this.showToast(`${label} deleted`);
        });
    };

    handleSetPriority = (type, id, val) => {
        let key = type === 'business' ? 'businesses' :
                  type === 'function' ? 'functions' :
                  type === 'kpi' ? 'kpis' : 'models';

        const updated = this.state[key].map(item => {
            if (item.id === id) {
                const nextItem = { ...item };
                if (val) nextItem.priority = val;
                else delete nextItem.priority;
                return nextItem;
            }
            return item;
        });

        this.saveState({ [key]: updated }, () => {
            this.showToast('Priority updated');
        });
    };

    handleCommitName = (type, id, val) => {
        const cleanVal = val.trim();
        const key = type === 'business' ? 'businesses' :
                    type === 'function' ? 'functions' :
                    type === 'kpi' ? 'kpis' : 'models';

        const obj = this.state[key].find(item => item.id === id);
        if (!obj) return;

        if (!cleanVal) {
            this.showToast('Name cannot be empty', true);
            return;
        }

        let siblings = [];
        if (type === 'business') {
            siblings = this.state.businesses.filter(b => b.id !== id);
        } else if (type === 'function') {
            siblings = this.state.functions.filter(f => f.id !== id && f.businessId === obj.businessId);
        } else if (type === 'model') {
            siblings = this.state.models.filter(m => m.id !== id && m.functionId === obj.functionId);
        } else if (type === 'kpi') {
            siblings = this.state.kpis.filter(k => k.id !== id && k.functionId === obj.functionId);
        }

        const isDuplicate = siblings.some(s => s.name.toLowerCase() === cleanVal.toLowerCase());
        if (isDuplicate) {
            this.showToast('Duplicate name in the same parent group', true);
            return;
        }

        const updated = this.state[key].map(item => 
            item.id === id ? { ...item, name: cleanVal } : item
        );

        this.saveState({ [key]: updated }, () => {
            this.showToast('Renamed');
        });
    };

    openEntityModal = (type, id = null, presetParentId = null) => {
        let name = '';
        let description = '';
        let priority = '';
        let formula = '';
        let kind = 'Forecasting';
        let parentId = presetParentId;

        if (id) {
            const key = type === 'business' ? 'businesses' :
                        type === 'function' ? 'functions' :
                        type === 'kpi' ? 'kpis' : 'models';
            const obj = this.state[key].find(item => item.id === id);
            if (obj) {
                name = obj.name;
                description = obj.description || '';
                priority = obj.priority || '';
                formula = obj.formula || '';
                kind = obj.kind || 'Forecasting';
                parentId = type === 'function' ? obj.businessId : 
                           (type === 'kpi' || type === 'model') ? obj.functionId : null;
            }
        } else {
            // Set default parentId if none is preset
            if (type === 'function') {
                parentId = presetParentId || this.state.businesses[0]?.id || '';
            } else if (type === 'kpi' || type === 'model') {
                parentId = presetParentId || this.state.functions[0]?.id || '';
            }
        }

        this.setState({
            entityModal: {
                show: true,
                type,
                id,
                presetParentId: parentId,
                name,
                description,
                priority,
                formula,
                kind,
                errors: {}
            }
        });
    };

    handleEntityModalSave = () => {
        const { type, id, presetParentId, name, description, priority, formula, kind } = this.state.entityModal;
        const cleanName = name.trim();
        const errors = {};

        if (!cleanName) {
            errors.name = 'Name is required';
        }

        if (Object.keys(errors).length > 0) {
            this.setState(prevState => ({
                entityModal: { ...prevState.entityModal, errors }
            }));
            return;
        }

        const key = type === 'business' ? 'businesses' :
                    type === 'function' ? 'functions' :
                    type === 'kpi' ? 'kpis' : 'models';

        let nextItems = [...this.state[key]];
        const stateKey = key;

        if (id) {
            nextItems = nextItems.map(item => {
                if (item.id === id) {
                    const next = { ...item, name: cleanName, description, priority };
                    if (type === 'kpi') next.formula = formula;
                    if (type === 'model') next.kind = kind;
                    return next;
                }
                return item;
            });
        } else {
            const generatedId = type.charAt(0) + Math.random().toString(36).substr(2, 9);
            const newItem = {
                id: generatedId,
                name: cleanName,
                description,
                priority,
                active: true
            };

            if (type === 'function') {
                newItem.businessId = presetParentId || this.state.businesses[0]?.id;
            } else if (type === 'kpi' || type === 'model') {
                newItem.functionId = presetParentId || this.state.functions[0]?.id;
                if (type === 'kpi') newItem.formula = formula;
                if (type === 'model') newItem.kind = kind;
            }

            nextItems.push(newItem);
        }

        this.saveState({ [stateKey]: nextItems }, () => {
            this.setState(prevState => ({
                entityModal: { ...prevState.entityModal, show: false }
            }));
            this.showToast(id ? 'Saved changes' : 'Added item');
        });
    };

    openQuickAddModal = () => {
        this.setState({
            quickAddModal: {
                show: true,
                name: '',
                description: '',
                functions: [
                    { name: '', description: '', kpis: [], models: [] }
                ],
                errors: {}
            }
        });
    };

    handleQuickAddSave = () => {
        const { name, description, functions } = this.state.quickAddModal;
        const cleanName = name.trim();
        const errors = {};

        if (!cleanName) {
            errors.name = 'Business name is required';
        }

        if (Object.keys(errors).length > 0) {
            this.setState(prevState => ({
                quickAddModal: { ...prevState.quickAddModal, errors }
            }));
            return;
        }

        const bizId = 'b' + Math.random().toString(36).substr(2, 9);
        const nextBusinesses = [...this.state.businesses, {
            id: bizId,
            name: cleanName,
            description,
            active: true
        }];

        let nextFunctions = [...this.state.functions];
        let nextKpis = [...this.state.kpis];
        let nextModels = [...this.state.models];

        let addedF = 0;
        let addedK = 0;
        let addedM = 0;

        functions.forEach(f => {
            const cleanFnName = f.name.trim();
            if (!cleanFnName) return;

            const fnId = 'f' + Math.random().toString(36).substr(2, 9);
            nextFunctions.push({
                id: fnId,
                businessId: bizId,
                name: cleanFnName,
                description: f.description,
                active: true
            });
            addedF++;

            f.kpis.forEach(k => {
                const cleanKName = k.name.trim();
                if (!cleanKName) return;

                nextKpis.push({
                    id: 'k' + Math.random().toString(36).substr(2, 9),
                    functionId: fnId,
                    name: cleanKName,
                    description: k.description,
                    formula: k.formula,
                    active: true
                });
                addedK++;
            });

            f.models.forEach(m => {
                const cleanMName = m.name.trim();
                if (!cleanMName) return;

                nextModels.push({
                    id: 'md' + Math.random().toString(36).substr(2, 9),
                    functionId: fnId,
                    name: cleanMName,
                    description: m.description,
                    kind: m.kind || 'Forecasting',
                    active: true
                });
                addedM++;
            });
        });

        this.saveState({
            businesses: nextBusinesses,
            functions: nextFunctions,
            kpis: nextKpis,
            models: nextModels
        }, () => {
            this.setState(prevState => ({
                quickAddModal: { ...prevState.quickAddModal, show: false }
            }));
            
            const reports = [`${addedF} function${addedF !== 1 ? 's' : ''}`];
            if (addedK) reports.push(`${addedK} KPI${addedK !== 1 ? 's' : ''}`);
            if (addedM) reports.push(`${addedM} model${addedM !== 1 ? 's' : ''}`);
            
            this.showToast(`Added ${cleanName} · ${reports.join(' · ')}`);
        });
    };

    handleQuickAddBizInput = (field, val) => {
        this.setState(prevState => ({
            quickAddModal: {
                ...prevState.quickAddModal,
                [field]: val
            }
        }));
    };

    handleQuickAddFnChange = (index, field, val) => {
        this.setState(prevState => {
            const nextFns = [...prevState.quickAddModal.functions];
            nextFns[index] = { ...nextFns[index], [field]: val };
            return {
                quickAddModal: {
                    ...prevState.quickAddModal,
                    functions: nextFns
                }
            };
        });
    };

    handleQuickAddMoreFn = () => {
        this.setState(prevState => ({
            quickAddModal: {
                ...prevState.quickAddModal,
                functions: [
                    ...prevState.quickAddModal.functions,
                    { name: '', description: '', kpis: [], models: [] }
                ]
            }
        }));
    };

    handleQuickRemoveFn = (index) => {
        this.setState(prevState => {
            let nextFns = prevState.quickAddModal.functions.filter((_, i) => i !== index);
            if (nextFns.length === 0) {
                nextFns = [{ name: '', description: '', kpis: [], models: [] }];
            }
            return {
                quickAddModal: {
                    ...prevState.quickAddModal,
                    functions: nextFns
                }
            };
        });
    };

    handleQuickAddKpi = (fnIndex) => {
        this.setState(prevState => {
            const nextFns = [...prevState.quickAddModal.functions];
            const nextKpis = [...(nextFns[fnIndex].kpis || [])];
            nextKpis.push({ name: '', description: '', formula: '' });
            nextFns[fnIndex] = { ...nextFns[fnIndex], kpis: nextKpis };
            return {
                quickAddModal: {
                    ...prevState.quickAddModal,
                    functions: nextFns
                }
            };
        });
    };

    handleQuickRemoveKpi = (fnIndex, kpiIndex) => {
        this.setState(prevState => {
            const nextFns = [...prevState.quickAddModal.functions];
            const nextKpis = nextFns[fnIndex].kpis.filter((_, i) => i !== kpiIndex);
            nextFns[fnIndex] = { ...nextFns[fnIndex], kpis: nextKpis };
            return {
                quickAddModal: {
                    ...prevState.quickAddModal,
                    functions: nextFns
                }
            };
        });
    };

    handleQuickAddKpiChange = (fnIndex, kpiIndex, field, val) => {
        this.setState(prevState => {
            const nextFns = [...prevState.quickAddModal.functions];
            const nextKpis = [...nextFns[fnIndex].kpis];
            nextKpis[kpiIndex] = { ...nextKpis[kpiIndex], [field]: val };
            nextFns[fnIndex] = { ...nextFns[fnIndex], kpis: nextKpis };
            return {
                quickAddModal: {
                    ...prevState.quickAddModal,
                    functions: nextFns
                }
            };
        });
    };

    handleQuickAddModel = (fnIndex) => {
        this.setState(prevState => {
            const nextFns = [...prevState.quickAddModal.functions];
            const nextModels = [...(nextFns[fnIndex].models || [])];
            nextModels.push({ name: '', description: '', kind: 'Forecasting' });
            nextFns[fnIndex] = { ...nextFns[fnIndex], models: nextModels };
            return {
                quickAddModal: {
                    ...prevState.quickAddModal,
                    functions: nextFns
                }
            };
        });
    };

    handleQuickRemoveModel = (fnIndex, modelIndex) => {
        this.setState(prevState => {
            const nextFns = [...prevState.quickAddModal.functions];
            const nextModels = nextFns[fnIndex].models.filter((_, i) => i !== modelIndex);
            nextFns[fnIndex] = { ...nextFns[fnIndex], models: nextModels };
            return {
                quickAddModal: {
                    ...prevState.quickAddModal,
                    functions: nextFns
                }
            };
        });
    };

    handleQuickAddModelChange = (fnIndex, modelIndex, field, val) => {
        this.setState(prevState => {
            const nextFns = [...prevState.quickAddModal.functions];
            const nextModels = [...nextFns[fnIndex].models];
            nextModels[modelIndex] = { ...nextModels[modelIndex], [field]: val };
            nextFns[fnIndex] = { ...nextFns[fnIndex], models: nextModels };
            return {
                quickAddModal: {
                    ...prevState.quickAddModal,
                    functions: nextFns
                }
            };
        });
    };

    customGetActionComponent = (actionType, headerValue, cell, tableProps, rowIndex) => {
        const rowDataList = tableProps.data?.data;
        if (!rowDataList || !rowDataList[rowIndex]) return null;

        const row = cell?.row || rowDataList[rowIndex][0]?.row;
        const cleanHeader = headerValue.replace(' ⇅', '').trim();

        if (!row || row.isDummy) {
            if (headerValue.trim() === "" && row && row.isDummy) {
                return <span className="kr-dummy-marker" />;
            }
            return null;
        }

        if (cleanHeader === "Active") {
            const type = row.type;
            const isOwnActive = row.active;
            const isAncestorInactive = type === 'function' ? !this.isBizEff(this.getBiz(row.businessId)) :
                                       (type === 'kpi' || type === 'model') ? !this.isFnEff(this.getFn(row.functionId)) : false;
            return (
                <div className="tw-text-center tw-flex tw-justify-center">
                    <Form.Check 
                        type="switch"
                        id={`active-switch-${row.id}`}
                        checked={isOwnActive}
                        disabled={isAncestorInactive}
                        onChange={() => !isAncestorInactive && this.handleToggleActive(type, row.id)}
                        className="tw-cursor-pointer"
                    />
                </div>
            );
        }

        if (cleanHeader === "Name") {
            const { type, depth, openState, name, id } = row;
            const hasChildren = type === 'business' || type === 'function';
            const paddingLeft = depth * 22 + 12;

            const levelIcon = type === 'business' ? BIZ_SVG :
                              type === 'function' ? FN_SVG :
                              type === 'kpi' ? KPI_SVG : MDL_SVG;

            let childMeta = '';
            if (type === 'business') {
                childMeta = `${this.getFnsOf(id).length} fn`;
            } else if (type === 'function') {
                const kpiCount = this.getKpisOf(id).length;
                const modelCount = this.getModelsOf(id).length;
                childMeta = modelCount > 0
                    ? `${kpiCount} KPI · ${modelCount} model`
                    : `${kpiCount} KPI`;
            }

            // Guide lines based on depth
            const guideLines = [];
            for (let d = 0; d < depth; d++) {
                const lineLeft = d * 22 + 12 + 7 + 10; // aligned to the chevron center (accounting for 10px td padding)
                guideLines.push(
                    <div 
                        key={d} 
                        className="tw-absolute tw-w-[1px] tw-bg-[#E9EAEB] dark:tw-bg-white/10" 
                        style={{ left: `${lineLeft}px`, top: '0px', bottom: '0px', zIndex: 1 }} 
                    />
                );
            }

            return (
                <div className="tw-flex tw-items-center tw-justify-between tw-w-full tw-gap-1.5 tw-min-w-[280px]">
                    {guideLines}
                    <div className="tw-flex tw-items-center tw-gap-1.5" style={{ paddingLeft: `${paddingLeft}px` }}>
                        {hasChildren ? (
                            <button 
                                type="button"
                                onClick={() => this.handleToggleNode(type[0] + id)}
                                className="tw-bg-transparent tw-border-none tw-p-0 tw-inline-flex tw-items-center focus:tw-outline-none tw-cursor-pointer"
                            >
                                <ChevronRight className={`tw-w-3.5 tw-h-3.5 tw-inline-block tw-transition-transform tw-duration-180 tw-shrink-0 ${openState ? 'tw-rotate-90' : ''}`} />
                            </button>
                        ) : (
                            <span className="tw-w-3.5 tw-inline-block tw-shrink-0" />
                        )}

                        <span className="tw-text-[#788097] dark:tw-text-white tw-shrink-0">{levelIcon}</span>

                        <span 
                            className="tw-text-[#181D27] dark:tw-text-white tw-font-semibold tw-text-sm tw-py-1 tw-inline-block tw-max-w-[200px] tw-truncate tw-align-middle"
                            title={name}
                        >
                            {name}
                        </span>
                    </div>

                    <div className="tw-flex tw-items-center tw-gap-1.5 tw-shrink-0">
                        {childMeta && (
                            <span className="tw-text-[10px] tw-font-medium tw-text-[#7e7e7e] tw-bg-[#F5F5F5] dark:tw-bg-white/10 tw-px-1.5 tw-py-0.5 tw-rounded tw-whitespace-nowrap">
                                {childMeta}
                            </span>
                        )}
                    </div>
                </div>
            );
        }

        if (cleanHeader === "Description") {
            return (
                <span 
                    className="tw-text-[#535862] dark:tw-text-[#B2B5BE] tw-text-sm tw-font-normal tw-block tw-max-w-[420px]" 
                    style={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        wordBreak: 'break-word',
                        whiteSpace: 'normal'
                    }}
                    title={cell}
                >
                    {cell}
                </span>
            );
        }

        if (cleanHeader === "Type") {
            const { type, kind } = row;
            return type === 'model' ? (
                <span className="tw-inline-flex tw-items-center tw-gap-5 tw-text-purple-700 tw-border tw-border-solid tw-border-purple-200 tw-bg-purple-50 tw-text-[11px] tw-font-semibold tw-px-2.5 tw-py-0.5 tw-rounded-full">
                    {kind || 'Model'}
                </span>
            ) : (
                <span className="tw-text-[12px] tw-text-gray-300">&mdash;</span>
            );
        }

        if (cleanHeader === "Mapped") {
            const { type, id } = row;
            const mappedCount = type === 'kpi' ? this.getMapsOf(id).length : 0;
            return type === 'kpi' ? (
                <span className={`tw-text-[12.5px] ${mappedCount > 0 ? 'tw-text-gray-500' : 'tw-text-amber-600'}`}>
                    {mappedCount} mapped
                </span>
            ) : (
                <span className="tw-text-[12px] tw-text-gray-300">&mdash;</span>
            );
        }

        if (cleanHeader === "Priority") {
            const { type, id, priority } = row;
            const prioVal = priority || '';
            const isDark = document.documentElement.classList.contains('tw-dark');
 
            const customSelectStyles = {
                control: (base) => ({
                    ...base,
                    minHeight: '24px',
                    height: '24px',
                    borderRadius: '6px',
                    border: isDark ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid #e2e8f0',
                    backgroundColor: isDark ? '#2B2B40' : '#ffffff',
                    '&:hover': {
                        borderColor: isDark ? 'rgba(255, 255, 255, 0.2)' : '#cbd5e1'
                    },
                    boxShadow: 'none',
                    fontSize: '11px',
                    fontWeight: '600',
                    cursor: 'pointer'
                }),
                valueContainer: (base) => ({
                    ...base,
                    padding: '0 8px',
                    height: '24px',
                    display: 'flex',
                    alignItems: 'center'
                }),
                singleValue: (base) => ({
                    ...base,
                    color: isDark ? '#ffffff' : '#181D27',
                    fontWeight: '600'
                }),
                placeholder: (base) => ({
                    ...base,
                    color: isDark ? '#ffffff' : '#181D27',
                    fontWeight: '600'
                }),
                indicatorsContainer: (base) => ({
                    ...base,
                    height: '24px'
                }),
                indicatorSeparator: () => ({
                    display: 'none'
                }),
                dropdownIndicator: (base) => ({
                    ...base,
                    padding: '0px 4px',
                    color: isDark ? '#B2B5BE' : '#475569',
                    '& svg': {
                        width: '12px',
                        height: '12px'
                    },
                    '&:hover': {
                        color: isDark ? '#ffffff' : '#0f172a'
                    }
                }),
                clearIndicator: (base) => ({
                    ...base,
                    padding: '0px 4px',
                    color: isDark ? '#B2B5BE' : '#475569',
                    '& svg': {
                        width: '12px',
                        height: '12px'
                    },
                    '&:hover': {
                        color: isDark ? '#ffffff' : '#0f172a'
                    }
                }),
                menu: (base) => ({
                    ...base,
                    backgroundColor: isDark ? '#1E1E2D' : '#ffffff',
                    border: isDark ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid #e2e8f0'
                }),
                option: (base, state) => ({
                    ...base,
                    color: isDark 
                        ? (state.isSelected ? '#ffffff' : '#B2B5BE') 
                        : (state.isSelected ? '#181D27' : '#475569'),
                    backgroundColor: state.isSelected 
                        ? (isDark ? '#3A3A55' : '#e2e8f0') 
                        : (state.isFocused 
                            ? (isDark ? '#2B2B40' : '#f1f5f9') 
                            : (isDark ? '#1E1E2D' : '#ffffff')),
                    '&:hover': {
                        backgroundColor: isDark ? '#2B2B40' : '#f1f5f9'
                    }
                }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 })
            };
 
            return (
                <div style={{ width: '100px' }}>
                    <Select 
                        value={PRIO_OPTS.find(o => o.value === prioVal) || null}
                        onChange={opt => this.handleSetPriority(type, id, opt ? opt.value : '')}
                        options={PRIO_OPTS}
                        className="select-control set-priority"
                        classNamePrefix='select-control'
                        placeholder="Set priority"
                        isClearable
                        menuPortalTarget={document.body}
                        styles={customSelectStyles}
                    />
                </div>
            );
        }

        if (cleanHeader === "Actions") {
            const { type, id } = row;
            return (
                <div className="tw-flex tw-items-center tw-justify-end tw-gap-[6px] tw-w-full">
                    {type === 'business' && (
                        <button
                            type="button"
                            onClick={() => this.openEntityModal('function', null, id)}
                            className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-border tw-border-solid tw-rounded-lg tw-transition-colors tw-text-[#1D4ED8] dark:tw-text-blue-400 tw-bg-[#EFF6FF] dark:tw-bg-blue-500/10 tw-border-[#BFDBFE] dark:tw-border-blue-500/20 hover:tw-bg-[#DBEAFE] dark:hover:tw-bg-blue-500/20 tw-cursor-pointer"
                        >
                            <Plus size={12} className="tw-stroke-[2.5]" />
                            <span>Function</span>
                        </button>
                    )}
                    {type === 'function' && (
                        <>
                            <button
                                type="button"
                                onClick={() => this.openEntityModal('kpi', null, id)}
                                className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-border tw-border-solid tw-rounded-lg tw-transition-colors tw-text-[#1D4ED8] dark:tw-text-blue-400 tw-bg-[#EFF6FF] dark:tw-bg-blue-500/10 tw-border-[#BFDBFE] dark:tw-border-blue-500/20 hover:tw-bg-[#DBEAFE] dark:hover:tw-bg-blue-500/20 tw-cursor-pointer"
                            >
                                <Plus size={12} className="tw-stroke-[2.5]" />
                                <span>KPI</span>
                            </button>
                            <button
                                type="button"
                                onClick={() => this.openEntityModal('model', null, id)}
                                className="d-none tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-border tw-border-solid tw-rounded-lg tw-transition-colors tw-text-[#7E22CE] dark:tw-text-purple-400 tw-bg-[#FAF5FF] dark:tw-bg-purple-500/10 tw-border-[#E9D5FF] dark:tw-border-purple-500/20 hover:tw-bg-[#F3E8FF] dark:hover:tw-bg-purple-500/20 tw-cursor-pointer"
                            >
                                <Plus size={12} className="tw-stroke-[2.5]" />
                                <span>Model</span>
                            </button>
                        </>
                    )}
                    <button
                        type="button"
                        onClick={() => this.openEntityModal(type, id)}
                        className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-border tw-border-solid tw-rounded-lg tw-transition-colors tw-text-[#374151] dark:tw-text-white tw-bg-white dark:tw-bg-[#2B2B40] tw-border-[#D5D7DA] dark:tw-border-white/10 hover:tw-bg-[#F9FAFB] dark:hover:tw-bg-[#3A3A55] tw-cursor-pointer"
                    >
                        <Pencil size={12} />
                        <span>Edit</span>
                    </button>
                    <button
                        type="button"
                        onClick={() => this.handleDeleteEntity(type, id)}
                        title="Delete"
                        className="tw-inline-flex tw-items-center tw-justify-center tw-w-[26px] tw-h-[26px] tw-text-xs tw-font-semibold tw-border tw-border-solid tw-rounded-lg tw-transition-colors tw-text-red-700 dark:tw-text-red-400 tw-bg-red-50 dark:tw-bg-red-500/10 tw-border-red-200 dark:tw-border-red-500/20 hover:tw-bg-red-100 dark:hover:tw-bg-red-500/20 tw-cursor-pointer"
                    >
                        <Trash2 size={12} />
                    </button>
                </div>
            );
        }

        return null;
    };

    render() {
        const { 
            businesses, 
            functions, 
            showInactive, 
            searchQuery, 
            showWorkflowGuide, 
            openNodes, 
            entityModal, 
            quickAddModal 
        } = this.state;

        const counts = this.getRegistryCounts();
        const q = searchQuery.trim().toLowerCase();

        const isMatched = (nodeName, nodeDesc) => {
            if (!q) return true;
            return (nodeName || '').toLowerCase().includes(q) || 
                   (nodeDesc || '').toLowerCase().includes(q);
        };

        const renderConfigureTable = () => {
            const listRows = [];
            businesses.forEach(b => {
                if (!showInactive && !b.active) return;
                
                const fns = this.getFnsOf(b.id).filter(f => showInactive || f.active);
                const bMatches = isMatched(b.name, b.description);
                const matchAnyFn = fns.some(f => {
                    const fMatches = isMatched(f.name, f.description);
                    const ks = this.getKpisOf(f.id).filter(k => showInactive || k.active);
                    const mds = this.getModelsOf(f.id).filter(m => showInactive || m.active);
                    
                    return fMatches || 
                           ks.some(k => isMatched(k.name, k.description)) || 
                           mds.some(m => isMatched(m.name, m.description));
                });

                if (q && !bMatches && !matchAnyFn) return;

                const isOpen = q ? true : (openNodes['b' + b.id] !== false);
                listRows.push({ ...b, type: 'business', depth: 0, openState: isOpen, openDropdownId: this.state.openDropdownId });

                if (isOpen) {
                    fns.forEach(f => {
                        const fMatches = isMatched(f.name, f.description);
                        const ks = this.getKpisOf(f.id).filter(k => showInactive || k.active);
                        const mds = this.getModelsOf(f.id).filter(m => showInactive || m.active);

                        if (q && !bMatches && !fMatches && 
                            !ks.some(k => isMatched(k.name, k.description)) && 
                            !mds.some(m => isMatched(m.name, m.description))) return;

                        const isFnOpen = q ? true : (openNodes['f' + f.id] === true);
                        listRows.push({ ...f, type: 'function', depth: 1, openState: isFnOpen, openDropdownId: this.state.openDropdownId });

                        if (isFnOpen) {
                            const kk = q ? ks.filter(k => isMatched(k.name, k.description) || fMatches || bMatches) : ks;
                            const mm = q ? mds.filter(m => isMatched(m.name, m.description) || fMatches || bMatches) : mds;

                            kk.forEach(k => listRows.push({ ...k, type: 'kpi', depth: 2, openState: null, openDropdownId: this.state.openDropdownId }));
                            mm.forEach(m => listRows.push({ ...m, type: 'model', depth: 2, openState: null, openDropdownId: this.state.openDropdownId }));
                        }
                    });
                }
            });

            //const headers = ["", "Active", "Name", "Description", "Type", "Mapped", "Priority", "Actions"];
            const headers = ["", "Active", "Name", "Description",  "Mapped", "Priority", "Actions"];
            const formattedRows = listRows.map((rowItem) => {
                return [
                    { type: "td", value: "", row: rowItem },
                    { type: "component", value: "", row: rowItem },
                    { type: "component", value: "", row: rowItem },
                    { type: "td", value: rowItem.description || "", row: rowItem },
                   // { type: "component", value: "", row: rowItem },
                    { type: "component", value: "", row: rowItem },
                    { type: "component", value: "", row: rowItem },
                    { type: "component", value: "", row: rowItem }
                ];
            });

            // Artificially pad the list with hidden dummy items to force QualdoDataTable's Search and Items length filters to show
            const realRowsCount = formattedRows.length;
            const targetLimit = 15;
            if (realRowsCount > 0 && realRowsCount <= targetLimit) {
                const padNeeded = (targetLimit + 1) - realRowsCount;
                for (let i = 0; i < padNeeded; i++) {
                    const dummyRow = { id: `dummy_${i}_${Math.random()}`, isDummy: true };
                    formattedRows.push([
                        { type: "td", value: "", row: dummyRow },
                        { type: "td", value: "", row: dummyRow },
                        { type: "td", value: "", row: dummyRow },
                        { type: "td", value: "", row: dummyRow },
                        { type: "td", value: "", row: dummyRow },
                        { type: "td", value: "", row: dummyRow },
                        { type: "td", value: "", row: dummyRow },
                        { type: "component", value: "", row: dummyRow }
                    ]);
                }
            }

            const tableData = {
                headers: headers,
                data: formattedRows,
                not_sortable: true
            };

            const pageOptions = [15, 25, 50, 100];

            return (
                <div id="kpi-registry-table-wrapper" className="hide-tbl-border-radius">
                    <style>{`
                        #kpi-registry-table-wrapper th:first-child,
                        #kpi-registry-table-wrapper td:first-child {
                            display: none !important;
                        }
                        #kpi-registry-table-wrapper td {
                            vertical-align: middle !important;
                            position: relative;
                        }
                        #kpi-registry-table-wrapper tr:has(.kr-dummy-marker) {
                            display: none !important;
                        }
                        #kpi-registry-table-wrapper th:last-child {
                            color: transparent !important;
                        }
                        #kpi-registry-table-wrapper th:last-child .order,
                        #kpi-registry-table-wrapper th:last-child .caret {
                            display: none !important;
                        }
                    `}</style>
                    {realRowsCount <= targetLimit && (
                        <style>{`
                            #kpi-registry-table-wrapper .react-bootstrap-table__footer {
                                display: none !important;
                            }
                        `}</style>
                    )}
                    <QualdoDataTable
                        id="kpiRegistryTable"
                        component_name="kpiRegistryTable"
                        classNameForTable="table"
                        wrapperClasses="table-responsive action"
                        data={tableData}
                        pageOptions={pageOptions}
                        paginationSize={15}
                        customGetActionComponent={this.customGetActionComponent}
                    />
                </div>
            );
        };

        return (
            <>
                {/* 1. Business Library Portlet */}
                <div className="portlet">
                    <div className="portlet-title tw-flex tw-items-center tw-justify-between after:!tw-content-none after:!tw-hidden before:!tw-content-none before:!tw-hidden !tw-border-none">
                        <div className="caption">
                            <span className="text-uppercase font-dark">Business library</span>
                            {/* <small className='tw-text-sm tw-text-[#535862] tw-block'>Define the governed hierarchy: Business &rarr; Function &rarr; KPI / Model. Map KPI data fields separately in Domain Mapping.</small> */}
                            <small className='tw-text-sm tw-text-[#535862] tw-block'>Define the governed hierarchy: Business &rarr; Function &rarr; KPI. Map KPI data fields separately in Domain Mapping.</small>

                        </div>
                        {/* <div className="actions !tw-flex tw-items-center tw-gap-4">
                            <button 
                                onClick={() => this.setState(prev => ({ showWorkflowGuide: !prev.showWorkflowGuide }))}
                                className="tw-h-7 tw-inline-flex tw-items-center tw-justify-center tw-gap-1 tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/10 tw-rounded-lg tw-bg-white dark:tw-bg-[#2B2B40] tw-text-[#374151] dark:tw-text-white tw-text-xs tw-font-semibold tw-px-2.5 tw-transition-colors hover:tw-bg-[#F9FAFB] dark:hover:tw-bg-[#3A3A55] tw-cursor-pointer"
                            >
                                <Info className="tw-w-3.5 tw-h-3.5" />
                                <span>{showWorkflowGuide ? 'Hide' : 'Show'} workflow guide</span>
                            </button>
                        </div> */}
                    </div>

                    <div className='portlet-body !tw-pt-0 tw-relative !tw-overflow-visible'>
                        {/* Modular KPI Summary Cards */}
                        <KpiDashboardCards counts={counts} showWorkflowGuide={showWorkflowGuide} />
                    </div>
                </div>

                {/* 2. Configure Library Portlet */}
                <div className="portlet pb-0">
                    <div className="portlet-title tw-flex tw-items-center tw-justify-between after:!tw-content-none after:!tw-hidden before:!tw-content-none before:!tw-hidden">
                        <div className="caption">
                            <span className="text-uppercase font-dark">Configure Library</span>
                            <small className='tw-text-sm tw-text-[#535862] tw-block'>Rename inline, add children from each row, and use toggles to activate or deactivate without deleting records.</small>
                        </div>
                        <div className="actions !tw-flex tw-items-center tw-gap-2">
                            {!this.state.isFullyExpanded ?
                                <button
                                    onClick={this.handleExpandAll}
                                    className="tw-h-7 tw-inline-flex tw-items-center tw-justify-center tw-gap-1 tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/10 tw-rounded-lg tw-bg-white dark:tw-bg-[#2B2B40] tw-text-[#374151] dark:tw-text-white tw-text-[11.5px] tw-font-semibold tw-px-2.5 tw-transition-colors hover:tw-bg-[#F9FAFB] dark:hover:tw-bg-[#3A3A55] tw-cursor-pointer"
                                >
                                    <ChevronsDown className="tw-w-3.5 tw-h-3.5" />
                                    <span>Expand all</span>
                                </button>
                                :
                                <button
                                    onClick={this.handleCollapseAll}
                                    className="tw-h-7 tw-inline-flex tw-items-center tw-justify-center tw-gap-1 tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/10 tw-rounded-lg tw-bg-white dark:tw-bg-[#2B2B40] tw-text-[#374151] dark:tw-text-white tw-text-[11.5px] tw-font-semibold tw-px-2.5 tw-transition-colors hover:tw-bg-[#F9FAFB] dark:hover:tw-bg-[#3A3A55] tw-cursor-pointer"
                                >
                                    <ChevronsUp className="tw-w-3.5 tw-h-3.5" />
                                    <span>Collapse all</span>
                                </button>
                            }
                        </div>
                    </div>

                    <div className='portlet-body !tw-p-0 tw-relative !tw-overflow-visible'>
                        {/* Controls Sub-header */}
                        <div className="tw-p-4 tw-flex tw-items-center tw-justify-between tw-gap-4 tw-flex-nowrap tw-bg-white dark:tw-bg-[#1E1E2D]">
                            <div className="tw-flex tw-items-center tw-shrink-0">
                                <button
                                    type="button"
                                    onClick={() => this.setState({ showInactive: !showInactive })}
                                    className="tw-inline-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-border tw-border-solid tw-rounded-lg tw-transition-colors tw-text-[#374151] dark:tw-text-white tw-bg-white dark:tw-bg-[#2B2B40] tw-border-[#D5D7DA] dark:tw-border-white/10 hover:tw-bg-[#F9FAFB] dark:hover:tw-bg-[#3A3A55] tw-cursor-pointer tw-h-[38px]"
                                >
                                    <input 
                                        type="checkbox" 
                                        checked={showInactive}
                                        readOnly
                                        className="tw-w-[15px] tw-h-[15px] tw-rounded tw-accent-blue-600 tw-cursor-pointer"
                                    />
                                    <span>Show inactive</span>
                                </button>
                            </div>

                            <div className="tw-relative tw-flex-1 tw-max-w-[750px]">
                                <span className="tw-absolute tw-left-3 tw-top-1/2 tw-translate-y-[-50%] tw-text-gray-400">
                                    <Search size={16} />
                                </span>
                                <input 
                                    type="text" 
                                    placeholder="Search business, function, KPI..."
                                    value={searchQuery}
                                    onChange={e => this.setState({ searchQuery: e.target.value })}
                                    className="tw-w-full tw-pl-10 tw-pr-4 tw-py-2 tw-text-sm tw-text-[#171717] dark:tw-text-white tw-bg-white dark:tw-bg-[#2B2B40] tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/10 tw-rounded-lg focus:tw-outline-none focus:tw-border-[#4F46E5] dark:focus:tw-border-[#818CF8]"
                                />
                            </div>

                            <div className="tw-flex tw-items-center tw-gap-3 tw-shrink-0">
                                {/* <button 
                                    onClick={() => this.openEntityModal('business')} 
                                    className="tw-inline-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-border tw-border-solid tw-rounded-lg tw-transition-colors tw-text-[#374151] dark:tw-text-white tw-bg-white dark:tw-bg-[#2B2B40] tw-border-[#D5D7DA] dark:tw-border-white/10 hover:tw-bg-[#F9FAFB] dark:hover:tw-bg-[#3A3A55] tw-cursor-pointer"
                                >
                                    <Plus size={16} />
                                    <span>Add Business</span>
                                </button> */}
                                <button 
                                    onClick={this.openQuickAddModal} 
                                    className="tw-inline-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-bg-[#EF4444] hover:tw-bg-[#DC2626] tw-rounded-lg tw-transition-colors tw-border-none tw-cursor-pointer"
                                >
                                    <Plus size={16} />
                                    <span>Add New</span>
                                </button>
                            </div>
                        </div>

                        {/* Table Body */}
                        <div id="kpi-body" className="tw-p-0">
                            {renderConfigureTable()}
                        </div>
                    </div>
                </div>

                {/* MODAL DIALOGS */}
                {/* Delete Warning Modal */}
                <DeleteWarningModal 
                    delete_show={this.state.showDeleteModal}
                    deleteClose={() => this.setState({ showDeleteModal: false, deleteTarget: { type: null, id: null } })}
                    handleDeleteFunction={this.handleConfirmDelete}
                    component={this.state.deleteTarget.type || "KPI Item"}
                    modalTitle={this.state.deleteTarget.type ? (this.state.deleteTarget.type.charAt(0).toUpperCase() + this.state.deleteTarget.type.slice(1)) : "KPI Item"}
                />

                {/* Deactivate Warning Modal */}
                {this.state.showDeactivateModal && (() => {
                    const { type, id } = this.state.deactivateTarget;
                    const obj = type === 'business' ? this.getBiz(id) :
                                type === 'function' ? this.getFn(id) : null;
                    if (!obj) return null;

                    const label = type === 'business' ? 'Business' : 'Function';
                    let childCount = 0;
                    if (type === 'business') {
                        childCount = this.getFnsOf(id).length;
                    } else if (type === 'function') {
                        childCount = this.getKpisOf(id).length + this.getModelsOf(id).length;
                    }

                    return (
                        <Modal show={this.state.showDeactivateModal} centered onHide={() => this.setState({ showDeactivateModal: false, deactivateTarget: { type: null, id: null } })}>
                            <Modal.Header closeButton className="d-none">
                                <h5 className="modal-title">{`Deactivate ${label}`}</h5>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="modal__alert">
                                    <div className="modal_alert-icon">
                                        <i className="text-danger">
                                            <FontAwesomeIcon icon={faToggleOn} />
                                        </i>
                                    </div>
                                    <div className="confirmation-alert_text">
                                        <h4>{`Deactivate ${label}?`}</h4>
                                        <p>
                                            Please confirm the name of the {type} to deactivate: <strong>{obj.name}</strong>
                                        </p>
                                    </div>

                                    <div className="confirmation-alert_form">
                                        <div className="alert alert-danger text-left">
                                            <i className="text-danger mr-2">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                            </i>
                                            <strong>{obj.name}</strong> has {childCount} child item(s). They'll be greyed out as <em>inactive</em> and their data-asset mappings will be locked in Domain Mapping — nothing is deleted. Reactivate any time to restore.
                                        </div>
                                    </div>

                                    <div className="modal_alert-btn-group">
                                        <button 
                                            type="button" 
                                            onClick={() => this.setState({ showDeactivateModal: false, deactivateTarget: { type: null, id: null } })}
                                            className="btn btn-outline btn-grey btn-circle mr-2"
                                        >
                                            Cancel
                                        </button>
                                        <button 
                                            type="button"
                                            onClick={this.handleConfirmDeactivate}
                                            className="btn btn-primary btn-circle mr-2"
                                        >
                                            Deactivate
                                        </button>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                    );
                })()}

                {/* 2. Add / Edit Entity Modal */}
                <EntityModal 
                    show={entityModal.show}
                    onClose={() => this.setState({ entityModal: { ...entityModal, show: false } })}
                    onSave={this.handleEntityModalSave}
                    entityModal={entityModal}
                    businesses={businesses}
                    functions={functions}
                    onChange={(field, val) => this.setState(prev => ({
                        entityModal: {
                            ...prev.entityModal,
                            [field]: val,
                            errors: { ...prev.entityModal.errors, [field]: '' }
                        }
                    }))}
                />

                {/* 3. Quick Add Modal */}
                <QuickAddModal 
                    show={quickAddModal.show}
                    onClose={() => this.setState({ quickAddModal: { ...quickAddModal, show: false } })}
                    onSave={this.handleQuickAddSave}
                    quickAddModal={quickAddModal}
                    onBizInput={this.handleQuickAddBizInput}
                    onFnChange={this.handleQuickAddFnChange}
                    onMoreFn={this.handleQuickAddMoreFn}
                    onRemoveFn={this.handleQuickRemoveFn}
                    onAddKpi={this.handleQuickAddKpi}
                    onRemoveKpi={this.handleQuickRemoveKpi}
                    onKpiChange={this.handleQuickAddKpiChange}
                    onAddModel={this.handleQuickAddModel}
                    onRemoveModel={this.handleQuickRemoveModel}
                    onModelChange={this.handleQuickAddModelChange}
                />
            </>
        );
    }
}

export default KpiCatalogWorkspace;
